import billingsTaxiOrderListingFactory from "../../common/billings-taxi-order-listing.factory";

const billingsTaxiOrderListingByTaxiFactory = {
  createListingItems: billingsTaxiOrderListingFactory.createListingItems,
  createStatsSummary: billingsTaxiOrderListingFactory.createStatsSummary,
};

export default billingsTaxiOrderListingByTaxiFactory;
